import { FileAttachment } from "./FileAttachment"
import { CheckList } from "./CheckList"
import { GeoLocation } from "./Location"

export interface DocumentMember {
    userUUID: string
}

export enum DueDateReccuring {
    NotReccuring = 0,
    Daily = 1,
    Weekly = 2,
    Monthly = 3,
    Yearly = 4
}

export interface RelatedDocument {
    creatorUid: string
    relatedDocumentId: string
    title: string
    linkedOn: string
    dataType: DocumentDataType

    //New fields, will be undefined in old links
    businessId?: string
    authourUid?: string
    docTimestamp?: string
    isHidden?: boolean
}

export type MustReadUsersList = string[]

export type SystemNativeDataTypes = 'post' | 'bookmark' | 'contact' | 'company' | 'event' | 'mail' | 'media' | 'question' | 'file' | 'code' | 'htmlwysiwyg' | 'poll'
export type CustomInputType = string
export type DocumentDataType = SystemNativeDataTypes | CustomInputType

export interface Document {
    docId: string
    groupUid: string | null
    organizationUid: string
    members: DocumentMember[]
    userUUID: string
    userName: string
    dataType: DocumentDataType
    mimeType: string
    title: string
    docText: string
    postText: string
    docTimestamp: string
    isPrivate: boolean,
    isLimitedToMembers: boolean
    mustReadUsers: MustReadUsersList | null
    mustReadUsersApproved: MustReadUsersList | null
    seen: string[]
    seenUsers: string[]
    lastModifiedTime?: string | null
    dueDateUTCDone?: string | null
    taskCounter?: number | null
    taskDoneCounter?: number | null
    links?: {title: string, link: string}[] | null
    seenCounter: number
    commentsCounter: number
    relatedDocuments: RelatedDocument[]
    link: string
    previewTitle: string
    previewDescription: string
    previewImgUrl: string
    jsonData: string | null
    dateTimeTo: string
    dateTimeFrom: string
    taskDueDateDone: boolean
    dueDateUTC: Date | null
    dueDateRecurring?: DueDateReccuring
    selectedComment: string | null
    taggedUsers: string[]
    docSize: number
    rating: number
    attachments: FileAttachment[]
    previewDescriptionJson: string | null
    aggregations: { [sourceField: string]: string }
    isEveryoneCanEdit: boolean
    checklists: CheckList[]
    collectionLabels: string[] | null
    locationAddress: string | null
    geoLocation: GeoLocation | null
    businessId: string | null
    CurrentStatus?: string | null
    TaskStatusColor?: number | null
    assignedResource?: string | null
    dependencies?: string[] | null
    relatedDocumentsCounter?: number | null
}